// extracted by mini-css-extract-plugin
export default {"auth-container":"auth_auth-container__Qyr59","auth":"auth_auth__XqBtq"};